/* TRYBUY collection image recovery, 19 Sep 2026.
 * Native responsive/lazy images remain the primary path. On an actual error,
 * try the original photo, then one other photo of that same product. No loop,
 * catalog writes, third-party requests, or polling. */
(function () {
  'use strict';
  if (window.tbCardImageRecoveryInstalled) return;
  window.tbCardImageRecoveryInstalled = true;
  var selector = '.collgrid img[data-tb-card-image]';
  var states = new WeakMap();

  function imageUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, document.baseURI);
      return url.protocol === 'https:' ? url.href : '';
    } catch (error) { return ''; }
  }

  function recover(img) {
    if (!img || !img.matches || !img.matches(selector)) return;
    // A transparent, intent-loaded second photo is not a broken product image.
    if (img.hasAttribute('data-src')) return;
    var state = states.get(img);
    if (!state) {
      state = { next: 0, tried: [img.currentSrc || img.src], urls: [
        imageUrl(img.getAttribute('data-tb-image-original')),
        imageUrl(img.getAttribute('data-tb-image-alternative'))
      ], done: false };
      states.set(img, state);
    }
    if (state.done) return;
    while (state.next < state.urls.length) {
      var url = state.urls[state.next++];
      if (!url || state.tried.indexOf(url) !== -1) continue;
      state.tried.push(url);
      img.setAttribute('data-tb-image-recovering', 'true');
      // Otherwise currentSrc can keep selecting the same failed srcset URL.
      img.removeAttribute('srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('sizes');
      img.src = url;
      return;
    }
    state.done = true;
    img.removeAttribute('data-tb-image-recovering');
    img.setAttribute('data-tb-image-failed', 'true');
    var link = img.closest('a');
    if (link && !link.querySelector('.tb-image-unavailable')) {
      var message = document.createElement('span');
      message.className = 'tb-image-unavailable';
      message.textContent = 'Image unavailable — View product';
      link.appendChild(message);
    }
  }

  document.addEventListener('error', function (event) { recover(event.target); }, true);
  document.addEventListener('load', function (event) {
    var img = event.target;
    if (!img || !img.matches || !img.matches(selector) || img.naturalWidth === 0) return;
    img.removeAttribute('data-tb-image-recovering');
    img.removeAttribute('data-tb-image-failed');
    var link = img.closest('a');
    var message = link && link.querySelector('.tb-image-unavailable');
    if (message) message.remove();
  }, true);

  function scan(root) {
    (root || document).querySelectorAll(selector).forEach(function (img) {
      // Covers failures that occurred before this deferred script executed.
      if (img.complete && img.naturalWidth === 0) recover(img);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  } else { scan(document); }
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
